export enum SamplingJobValidationStatus {
  okay = 1,
  warn = 2,
  error = 3,
}

export interface SamplingJobValidation {
  status: SamplingJobValidationStatus;
  title?: string;
  description?: string;
}
